var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLaughIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 122.88",
    style: {
      enableBackground: "new 0 0 122.88 122.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FBD433;} .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#141518;} .st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;} .st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FF0000;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.54,2.11c32.77-8.78,66.45,10.67,75.23,43.43c8.78,32.77-10.67,66.45-43.43,75.23 c-32.77,8.78-66.45-10.67-75.23-43.43C-6.67,44.57,12.77,10.89,45.54,2.11L45.54,2.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.89,27.86c4.3,0,7.78,4.91,7.78,10.97c0,6.06-3.48,10.97-7.78,10.97s-7.78-4.91-7.78-10.97 C34.11,32.77,37.59,27.86,41.89,27.86L41.89,27.86z M28.55,67.12c16.68-0.52,51.01,0.29,65.78-0.04 C94.33,106.85,28.55,110.65,28.55,67.12L28.55,67.12z M80.99,27.86c4.3,0,7.78,4.91,7.78,10.97c0,6.06-3.48,10.97-7.78,10.97 c-4.3,0-7.78-4.91-7.78-10.97C73.21,32.77,76.69,27.86,80.99,27.86L80.99,27.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.55,67.12c16.68-1.52,51.01-0.67,65.78-0.04C94.52,81.23,28.75,81.05,28.55,67.12L28.55,67.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M38.6,90.95c11.11,9.61,31.84,9.99,44.3,0c-6.78-7.71-14.18-7.95-22.39-1.88 C52.05,82.3,46.38,82.11,38.6,90.95L38.6,90.95z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaughIcon);
export default __webpack_public_path__ + "static/media/laugh-icon.3bbd83a59c6e947f57f15052266ab6e1.svg";
export { ForwardRef as ReactComponent };